//------------------------------------
// - mobile menu -
// give the ul/div you want as your mobile nav the id mainNav and it will become the mobile nav
//------------------------------------

//------------------------------------
// side container for nav to go into
//------------------------------------

var buildSidebar = function(){ 
    //create side nav container
    var sideNav = document.createElement('div');
    sideNav.className = "sidebar";
    sideNav.id = "sideBar";

    //copy mainnav and add to side nav container
    var mainNav = document.getElementById('mainNav');
    var navCopy = mainNav.cloneNode(true);

    //remove id for inside sideNav
    navCopy.id = "";
    sideNav.appendChild(navCopy);

    //append to body tag at the end
    var body = document.getElementsByTagName('body');
    body[0].appendChild(sideNav);

    //------------------
    // create back btn
    //------------------

    var backBtn = document.createElement('div');
    backBtn.className = "sidebar__back";
    //backBtn.innerHTML = "back";

    //hide by defualt so click event can still be setup
    backBtn.style.display = "none";

    //get sidenav for inserting back button before it
    var navContainer = document.getElementById("sideBar");

    //insert back button as first child to sidenav container
    navContainer.insertBefore(backBtn, navContainer.firstChild);

    //set up has btn check
    var hasBtn = false;

    //----------------------
    // create close button
    //----------------------

    var closeBtn = document.createElement('div');
    closeBtn.className = "sidebar__close";
    //add to navContainer
    navContainer.insertBefore(closeBtn, navContainer.firstChild);

    //toggle is-active class and reset all on close
    closeBtn.addEventListener("click", function () {
        //toggle class is-active
        navContainer.classList.toggle("is-active");
    });

    //-------------
    // hamburgar
    //-------------

    var hamBurger = document.querySelectorAll(".hamburger");

    hamBurger[0].addEventListener("click", function () {

        navContainer.classList.toggle("is-active");

        //added timer so css can hide and then js to reset
        setTimeout(function () { 
            //reset all hasNav--open 
            var elm = document.getElementsByClassName("has-subnav--open");
            for (var i = 0; i < elm.length; i++) {
                elm[i].classList.remove("has-subnav--open");
            }

            //reset all style=display:none
            var lis = document.querySelectorAll("#sideBar li");
            for (var i = 0; i < lis.length; i++) {
                lis[i].removeAttribute("style");
            }

            //reset backbtn
            var backBtns = document.querySelectorAll(".sidebar__back");
            backBtns[0].style.display = "none";
            hasBtn = false;
        }, 400);
    });

    //--------------
    // li handler
    //--------------

    //get all uls that are inside of any lis in sideNav
    var innerUls = document.querySelectorAll("#sideBar li > ul");

    for (var i = 0; i < innerUls.length; i++){
        //add class hasNav to li
        innerUls[i].parentNode.className = "has-subnav";

        //add click event to li
        innerUls[i].parentNode.addEventListener("click", function () {

        //if hasnav clicked then display back btn
        if (!hasBtn) {
            backBtn.style.display = "block";
            //set hasBtn to true
            hasBtn = true;
        }

        //add class open
        this.classList.add("has-subnav--open");

        //get all siblings
        var group = this.parentNode.childNodes;

        //get all siblings minus the one currently clicked on
        var result = getSiblings(this, group);

        //hide all siblings but current

        for(var x = 0; x < result.length; x++){
            result[x].style.display = "none";
        }

        });
    }

    //--------------
    // back button
    //--------------

    var backBtns = document.querySelectorAll(".sidebar__back");

    backBtns[0].addEventListener("click", function () {
        //get nav that is currently open  
        var openNavs = document.querySelectorAll(".has-subnav--open");

        //get last array item e.g last item open
        var current = openNavs[openNavs.length - 1];

        //remove open class on highest open nav
        current.classList.remove("has-subnav--open");

        //get all siblings minus the one currently clicked on
        var result = getSiblings(current, current.parentNode.childNodes);

        //show all previous lis that were hidden before
        for(var i = 0; i < result.length; i++){
            result[i].style.display = "";
        }

        //hide button if in most upper level
        if (openNavs.length == 1) {
            backBtn.style.display = "none";
            hasBtn = false;
        }

    });

    //-------------------
    // helper functions
    //-------------------

    //get siblings for a needle in haystack and return everything but the one clicked on
    function getSiblings(needle, haystack) {
        var result = [];
        for(var i = 0; i < haystack.length; i++){
            if (haystack[i] != needle && haystack[i].nodeType == 1) {
                result.push(haystack[i]);
            }
        }
        return result;
    }
};

//using a small timeout to allow static partials to load first
setTimeout(function(){ 
    buildSidebar()
}, 200);




// WEBPACK FOOTER //
// ./scripts/mobileNav.js